import { createDomain } from 'effector';

export const SessionDomain = createDomain();
